import React, { memo, useCallback } from 'react';
import MuiPhoneNumber from 'material-ui-phone-number';
import BookingFormStore from 'Stores/BookingFormStore';
import getDerivedStore from 'Stores/getDerivedStore';
import TextInput from 'Components/Forms/Elements/TextInput';
import bemit from 'Functions/bemit';
import { isTrue } from 'Shared/utilities';
const phone_countries = ['fr'];
const fields = ['user[phone_number]', 'user[firstname]', 'user[lastname]', 'user[login]'];
export default memo(function BookingUserFields({
  ...props
}) {
  const errors = BookingFormStore.useState(s => s.status_messages || {});
  const state = BookingFormStore.useState(s => getDerivedStore(s, fields));
  const b2b = BookingFormStore.useState(s => isTrue(s.b2b));
  const handleChange = useCallback(function ({
    e,
    value,
    name
  }) {
    if (e === null) return; // mount

    BookingFormStore.update(function (store) {
      store[name] = value;
      store.status_messages[name] = undefined;
      delete store.status_messages[name];
      ['E_CODE', 'info', 'error', 'warning'].forEach(field => store[field] = undefined);
    });
  }, []);
  const handlePhoneChange = useCallback(function (value) {
    handleChange({
      e: undefined,
      value: value,
      name: 'user[phone_number]'
    });
  }, [handleChange]);
  const modifiers = ['reservation'].concat(props['white-label-booking'] ? ['white-label-booking'] : []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    className: bemit('c-form-element', modifiers) + ' u-margin-top-0',
    value: state['user[lastname]'],
    name: "user[lastname]",
    label: "Nom",
    required: true,
    variant: "outlined",
    status: errors
  }), /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    className: bemit('c-form-element', modifiers),
    value: state['user[firstname]'],
    name: "user[firstname]",
    label: "Pr\xE9nom",
    required: true,
    variant: "outlined",
    status: errors
  }), /*#__PURE__*/React.createElement(MuiPhoneNumber, {
    onChange: handlePhoneChange,
    className: bemit('c-form-element', modifiers),
    value: state['user[phone_number]'],
    onlyCountries: phone_countries,
    defaultCountry: "fr",
    countryCodeEditable: true,
    label: "Num\xE9ro de t\xE9l\xE9phone",
    variant: "outlined",
    fullWidth: true
  }), !b2b ? /*#__PURE__*/React.createElement(TextInput, {
    onChange: handleChange,
    value: state['user[login]'],
    className: bemit('c-form-element', modifiers),
    name: "user[login]",
    type: "text",
    required: true,
    label: "E-mail",
    autocomplete: "new-email",
    variant: "outlined",
    status: errors
  }) : undefined);
});
